<script lang="ts">import { Button } from "@infinitro/button";
import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { ModalDialog, pushModal } from "@infinitro/global";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const bgImgSrc = cfgToThemeCdnPath("/about-vip/modern/cta-bg.png");
const handleSignup = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
</script>

<section class="vip-cta">
	<div class="vip-cta-content">
		<VipModernEyebrow text={$t(Verbiage.join_now)} />

		<Text
			type="title"
			titleSize="h4"
			titleWeight="bold"
			textColor="white"
			textAlign="center"
			className="vip-cta-title"
		>
			{$t(Verbiage.vip_modern_transparent_rewards)}
		</Text>

		<Text type="body" bodySize="large" textAlign="center">
			{$t(Verbiage.vip_modern_cta_body)}
		</Text>

		<Button
			text={$t(Verbiage.vip_modern_register_cta)}
			variant="primary"
			minWidth
			fullWidthMobile
			onClick={handleSignup}
		/>
	</div>

	<img class="vip-cta-bg" src={bgImgSrc} alt={$t(Verbiage.illustration_alt, 'alts')} />
</section>

<style>
	.vip-cta {

		position: relative;

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 1rem;

		overflow: hidden;

		padding-top: 2rem;

		padding-bottom: 4rem;

		text-align: center
}

	.vip-cta-content {

		position: relative;

		z-index: 1;

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 1rem
}

	:global(.vip-cta-title) {

		font-size: 32px !important
}

	.vip-cta-bg {

		position: relative;

		margin-top: 2rem;

		height: auto;

		width: 100%;

		-o-object-fit: contain;

		   object-fit: contain
}

	@media (min-width: 1024px) {
		:global(.vip-cta-title) {

				font-size: 38px !important
		}
	}
</style>
